import { formatInTimeZone } from 'date-fns-tz';
import { t } from 'ttag';

import { DEFAULT_STYLE_CONFIG } from './shared';

// These are the API's appliedEntityType values, so the form value ships as-is.
export const SESSION_DISPLAY_MODE = {
  SHOW_ALL: 'all',
  TRACK: 'session_tracks',
  DAY: 'session_days',
  SPECIFIC: 'specific_sessions',
};

export const getSessionDisplayOptions = () => [
  { label: t`Show All`, value: SESSION_DISPLAY_MODE.SHOW_ALL },
  { label: t`By Track`, value: SESSION_DISPLAY_MODE.TRACK },
  { label: t`By Day`, value: SESSION_DISPLAY_MODE.DAY },
  { label: t`Specific Sessions`, value: SESSION_DISPLAY_MODE.SPECIFIC },
];

// Sessions have no Order by picker; every mode but Specific runs chronologically.
export const SESSION_DEFAULT_SORT = 'start_datetime';

// Always shown, so it isn't a checkbox.
export const SESSION_NAME_FIELDS = ['name'];

export const SESSION_ROLES_VIEW_FIELD = 'roles';

// -> fieldConfig.viewFields.
export const getSessionDefaultFieldOptions = () => [
  { label: t`Start and End Time`, value: 'start_datetime' },
  { label: t`Location`, value: 'location' },
  { label: t`Session Tracks`, value: 'tracks' },
];

// Nested under the `Session Capacity` parent that has no API token.
export const getSessionCapacityFieldOptions = () => [
  { label: t`Total Capacity`, value: 'capacity.total' },
  { label: t`Reserved Seats`, value: 'capacity.used' },
];

// A session belongs to the day it starts, in the event's timezone — the same
// rule the backend filters by. Anything else disagrees at midnight boundaries.
export const toSessionDays = (sessions, timezone) =>
  [
    ...new Set(
      sessions.map(({ startDatetime }) => formatInTimeZone(startDatetime, timezone, 'yyyy-MM-dd')),
    ),
  ].sort();

// One checkbox covers both ends of the range.
export const withEndDatetime = fields =>
  fields.flatMap(field => (field === 'start_datetime' ? [field, 'end_datetime'] : [field]));

export const SESSIONS_STYLE_CONFIG = {
  ...DEFAULT_STYLE_CONFIG,
  concurrentSessions: true,
  widgetFilters: { days: true, showSearch: true, tracks: true },
};
